// extracted by mini-css-extract-plugin
export var containerLeft = "uni-module--containerLeft--gYG47";
export var contentLeft = "uni-module--contentLeft--srfAz";
export var contentRight = "uni-module--contentRight--TPPBx";
export var image = "uni-module--image--g4mbV";
export var description = "uni-module--description--kb5Ub";
export var descriptionElement = "uni-module--descriptionElement--I-RKs";
export var title = "uni-module--title--Mbhp1";